import type { CCompanyDigitalizationTranslations } from "./pl";

export const de: CCompanyDigitalizationTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine untergeordneten Kataloge zum Anzeigen.",
  readMore: "Mehr erfahren",
};
